/** 主推位 **/
import { uniqueId } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

// 资源列表服务端数据转换
function resourceList2Server(reqData) {
    return {
        section_id: reqData.sectionId, // 默认section_id =1 的资源做主推位资源
        lang: reqData.lang,
        page: reqData.page || 1,
        size: reqData.size || 10
    };
}

// 主推位列表客户端数据转换
function resourceList2Client(result) {
    const list = result.list.map((item, index) => {
        return {
            uId: uniqueId(),
            index,
            id: item.id,
            type: item.resource_type === "video" ? i18n.t("zhiji.wiki.video") : i18n.t("zhiji.wiki.guides"),
            name: item.name,
            title: item.title,
            baseViews: item.resource && item.resource.base_views,
            views: item.resource && item.resource.views,
            baseLikeNum: item.resource && item.resource.base_like_num,
            likeNum: item.resource && item.resource.like_num,
            videoDuration: item.resource && item.resource.video_duration,
            viewDate:
                item.resource && item.resource.view_date
                    ? item.resource.view_date.split(" ")[0] != "0000-00-00"
                        ? item.resource.view_date.split(" ")[0]
                        : ""
                    : "",
            videoUrl: item.resource && item.resource.video_url,
            tipContent: item.resource && item.resource.content && cvtGuideContent(JSON.parse(item.resource.content)),
            tipTitle: item.resource && item.resource.name,
            tipUpdateTime: item.resource && item.resource.update_time,
            namePlatform: item.name_platform,
            image: item.image,
            nameStyle: item.name_style,
            resourceType: item.resource_type,
            resourceId: item.resource_id,
            icon: item.icon,
            lang: item.lang,
            sort: item.sort,
            sectionId: item.section_id
        };
    });

    return {
        count: result.count,
        list
    };
}

// 攻略内容客户端数据转换
function cvtGuideContent(content) {
    let ret = [];
    const widgetType = {
        image: "GuidePicture",
        text: "GuideText"
    };
    ret =
        content &&
        content.map(item => {
            return {
                uId: uniqueId(),
                updateState: "add",
                wtType: widgetType[item.div_item[0].type],
                image: item.div_item[0].image,
                content: item.div_item[0].content.replace(/\n/g, "<br/>"),
                float: "mid"
            };
        });

    return ret;
}

// 添加主推位服务端数据转换
function addResource2Server(reqData) {
    return {
        section_id: reqData.sectionId, // 栏目id
        section_type: reqData.sectionType || "",
        name_platform: reqData.namePlatform || "", // 平台名称
        name: reqData.name, // SDK名称
        name_style: reqData.nameStyle || "", // 名称样式
        title: reqData.title && reqData.title.join("||"), // 标题, 多标题以 || 分隔
        image: reqData.image, // 资源图片
        resource_type: reqData.resourceType, // 素材类型，tip、video、question
        resource_id: reqData.resourceId, // 素材id，tip_id,video_id,question_id
        resource: reqData.resource || "{}", // 被修改的资源属性
        question: reqData.question || "", // 提问内容
        icon: reqData.icon || "", // hot||new,多个以||分隔
        lang: reqData.lang || "", // 资源语言
        sort: reqData.sort // 资源顺序（int类型）
    };
}

// 更新主推位服务端数据转换
function updateResource2Server(reqData) {
    return {
        id: reqData.id, // 资源ID（int类型）
        section_id: reqData.sectionId, // 栏目id
        name_platform: reqData.namePlatform || "", // 平台名称
        name: reqData.name, // SDK名称
        name_style: reqData.nameStyle || "", // 名称样式
        title: reqData.title && reqData.title.join("||"), // 标题, 多标题以 || 分隔
        image: reqData.image, // 资源图片
        resource_type: reqData.resourceType, // 素材类型，tip、video、question
        resource_id: reqData.resourceId, // 素材id，tip_id,video_id,question_id
        resource: reqData.resource || "{}", // 被修改的资源属性
        question: reqData.question || "", // 提问内容
        icon: reqData.icon || "", // hot||new,多个以||分隔
        lang: reqData.lang || "", // 资源语言
        sort: reqData.sort // 资源顺序（int类型）
    };
}

// 删除主推位服务端数据转换
function deleteResource2Server(reqData) {
    return {
        id: reqData.id // 资源ID（int类型）
    };
}

// 移动主推位服务端数据转换
function moveResource2Server(reqData) {
    return {
        id: reqData.id, // 资源ID（int类型）
        sort: reqData.sort // 移动到的索引位置（int类型）
    };
}

// 批量编辑修改删除服务端数据转换
function batchSave2Server({ rowData, listData }) {
    let num = 0;
    for (let i = 0; i < listData.length; i++) {
        if (listData[i].action === "delete") {
            continue;
        }
        num++;
        listData[i].sort = num;

        if (listData[i].action !== "add") {
            listData[i].action = "update";
        }
    }
    let formData = new FormData();
    formData.append("section_id", rowData.id);
    formData.append("lang", rowData.lang);
    formData.append("resource_array", JSON.stringify(transResourceArr(listData)));

    return formData;
}

function transResourceArr(data) {
    // 过滤前端新增后删掉的数据
    let newData = data.filter(item => !(item.id === "" && item.action === "delete"));

    return newData.map(item => {
        return {
            id: item.id,
            name: item.name,
            title: typeof item.title === "string" ? item.title : item.title.join("||"),
            name_platform: item.namePlatform,
            image: item.image,
            name_style: item.nameStyle,
            resource_type: item.resourceType,
            resource_id: item.resourceId,
            icon: item.icon,
            lang: item.lang,
            sort: item.sort,
            opt: item.id ? item.action : "add",
            section_id: item.sectionId,
            resource: JSON.stringify({
                base_views: item.baseViews,
                views: item.views,
                base_like_num: item.baseLikeNum,
                like_num: item.likeNum,
                video_duration: item.videoDuration,
                view_date: item.viewDate ? (item.viewDate.split(" ")[0] !== "0000-00-00" ? item.viewDate.split(" ")[0] : "") : ""
            })
        };
    });
}

// 获取区块列表服务端数据转换
function sectionList2Server(reqData) {
    return {
        lang: reqData.lang,
        page: reqData.page || 1,
        size: reqData.size || 10,
        section_type: reqData.sectionType || "banner,list"
    };
}

// 获取区块列表客户端数据转换
function sectionList2Client(result) {
    const list = result.list.map(item => {
        return {
            id: item.id,
            type: item.section_type === "list" ? i18n.t("zhiji.wiki.videoTip") : item.section_type === "banner" ? i18n.t("zhiji.wiki.banner") : "",
            sort: item.sort,
            sectionTitle: item.section_title,
            sectionType: item.section_type,
            lang: item.lang,
            question: item.resource.length > 0 && item.resource[0].question,
            resourceId: item.resource.length > 0 && item.resource[0].resource_id,
            image: item.resource.length > 0 && item.resource[0].image,
            editId: item.resource.length > 0 && item.resource[0].id
        };
    });
    return {
        count: result.count,
        list
    };
}

// 添加区块服务端数据转换
function addSection2Server(reqData) {
    return {
        section_type: reqData.sectionType, // top 主推位; banner 引流位; list 区块 （对应前端：视频/攻略类）
        section_title: reqData.sectionTitle,
        lang: reqData.lang,
        sort: reqData.sort // int类型
    };
}

// 更新区块服务端数据转换
function updateSection2Server(reqData) {
    return {
        id: reqData.id,
        section_type: reqData.sectionType,
        section_title: reqData.sectionTitle,
        lang: reqData.lang,
        sort: reqData.sort
    };
}
// 更新区块客户端数据转换
function sectionData2Client(result) {
    return result && result[0]
        ? {
              sectionId: result[0].id,
              sectionType: result[0].section_type,
              sectionTitle: result[0].section_title,
              lang: result[0].lang,
              sort: result[0].sort
          }
        : null;
}

// 删除区块服务端数据转换
function deleteSection2Server(reqData) {
    return {
        id: reqData.id
    };
}

// 气泡问设置客户端转服务端
function bubbleSetting2Server(reqData) {
    return {
        classify: "BubbleQuestion",
        code: "BubbleQuestion",
        content: reqData.content && JSON.stringify(transBubbleSetContent(reqData.content)),
        lang: reqData.lang
    };
}

function transBubbleSetContent(content) {
    return {
        type: "text",
        text: content.text,
        url: "",
        value: content.value,
        word_count: content.wordCount,
        new_text: content.newText,
        link_word: content.linkWord.map(item => {
            return {
                index: item.id,
                word: item.word,
                link_type: item.type,
                question_id: item.questionId,
                color_key: "question",
                url: "",
                question: item.question
            };
        }),
        url_type: ""
    };
}
// 获取气泡问设置服务端转客户端
function getBubbleSetting2Client(result) {
    let ret = result.content ? JSON.parse(result.content) : null;
    return ret
        ? {
              linkwordtext: {
                  linkWord: ret.link_word.map(item => {
                      return {
                          id: item.index,
                          word: item.word,
                          type: item.link_type,
                          questionId: item.question_id,
                          url: "",
                          color: "rgb(191, 96,12)",
                          question: item.question
                      };
                  }),
                  text: ret.text,
                  value: ret.value,
                  wordCount: ret.word_count,
                  newText: ret.new_text
              }
          }
        : null;
}

// 热门搜索设置客户端转服务端
function hotSearch2Server(reqData) {
    return {
        classify: "HotSearch",
        code: "HotSearch",
        content: reqData.content,
        lang: reqData.lang
    };
}
// 获取热门搜索设置服务端转客户端
function getHotSearch2Client(result) {
    return result.content ? JSON.parse(result.content) : null;
}

export default {
    resourceList2Server,
    resourceList2Client,
    addResource2Server,
    updateResource2Server,
    deleteResource2Server,
    moveResource2Server,
    batchSave2Server,
    sectionList2Server,
    sectionList2Client,
    updateSection2Server,
    addSection2Server,
    sectionData2Client,
    deleteSection2Server,
    hotSearch2Server,
    bubbleSetting2Server,
    getBubbleSetting2Client,
    getHotSearch2Client
};
